export const COMPANY_CONSTRAINTS = {
    name: { maxLength: 60, label: 'Company name' },
    taxexemptnumber: { maxLength: 30, label: 'Tax exemption number' },
};
//# sourceMappingURL=constraints.js.map